import { Link } from '@tanstack/react-router'
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/shared/ui/button'

/**
 * A maioria das telas do nibo nasce aqui — é componente de primeira classe, não
 * fallback.
 *
 * As "ilustrações" do nibo são, na verdade, ícones monoline ampliados (~64px).
 * lucide ampliado reproduz isso com custo ZERO — nada de unDraw (pesado, estética
 * genérica que contradiz "marca própria") nem Lottie (~50 kB de runtime para um
 * empty state é absurdo).
 */
export interface EmptyStateProps {
  readonly icon: LucideIcon
  readonly title: string
  readonly description?: string
  readonly action?: ReactNode
  /**
   * Base vazia e filtro-sem-resultado são problemas DIFERENTES e merecem CTAs
   * diferentes ("Novo cliente" vs "Limpar filtros"). O nibo trata os dois igual;
   * nós não precisamos repetir o erro.
   */
  readonly reason?: 'no-data' | 'no-results'
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-16 text-center">
      {/* Decorativo: o <h2> carrega o significado. */}
      <Icon className="text-action size-16 stroke-[1.5]" aria-hidden />
      <h2 className="text-ink text-2xl font-semibold">{title}</h2>
      {description !== undefined && (
        <p className="text-ink-muted max-w-md text-sm">{description}</p>
      )}
      {action !== undefined && <div className="mt-2">{action}</div>}
    </div>
  )
}

/** Atalho para o CTA mais comum: um link que parece botão. */
export function EmptyStateAction({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Button variant="primary" size="lg" asChild>
      <Link to={to}>{children}</Link>
    </Button>
  )
}
